import { axiosDS } from '@pp/axios'
import { SimpleResponse } from 'Types/simpleResponse'
import { ResponseCatalog, RequestParams } from 'Models'
import { urls } from 'Constants/Urls'
import { serialize } from 'object-to-formdata'
import { ServiceNotification } from 'Pages/admin'

export const serviceNotificationsApi = {
	getAllServiceNotifications: async (params?: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<ServiceNotification>>(urls.pop_up.index, {
			params,
		})
		return res.data
	},
	getServiceNotification: async (id: number) => {
		const res = await axiosDS().get<ServiceNotification>(`${urls.pop_up.index}/${id}`)
		return res.data
	},
	createServiceNotification: async (data: ServiceNotification) => {
		const res = await axiosDS().post<ServiceNotification>(urls.pop_up.index, serialize({ data }))
		return res.data
	},
	updateServiceNotification: async (data: ServiceNotification) => {
		const res = await axiosDS().patch<ServiceNotification>(
			`${urls.pop_up.index}/${data.id}`,
			serialize({ data })
		)
		return res.data
	},
	deleteServiceNotification: async (id: number) => {
		const res = await axiosDS().delete<SimpleResponse>(`${urls.pop_up.index}/${id}`)
		return res.data
	},
	readServiceNotification: async (id: number) => {
		const res = await axiosDS().patch<SimpleResponse>(`${urls.pop_up.index}/${id}/complete`)
		return res.data
	},
}
